import React, { useState, useEffect, useCallback } from 'react';
import Header from './Header';
import Hero from './Hero';
import ViveLibreSection from './ViveLibreSection';
import Values from './Values';
import Services from './Services';
import Testimonials from './Testimonials';
import Gallery from './Gallery';
import Footer from './Footer';

import ComunidadPage from './ComunidadPage';
import MemberResetPasswordPage from './MemberResetPasswordPage';
import AdminLoginPage from './AdminLoginPage';
import MemberPerfilPage from './MemberPerfilPage';
import ShoppingCart from './ShoppingCart';
import Checkout from './Checkout';
import BienestarPage from './BienestarPage';
import ConoceColombiaPage from './ConoceColombiaPage';
import VoluntariadoPage from './VoluntariadoPage';
import ConectaTuCaminoPage from './ConectaTuCaminoPage';
import ContactoPage from './ContactoPage';
import ServiciosPage from './ServiciosPage';
import TiendaPage from './TiendaPage';
import GrowthPartnerPage from './GrowthPartnerPage';
// FrankensteinPage removido de lo público (proyecto pausado, no cancelado)
import QuienesSomosPage from './QuienesSomosPage';
import NewsPage from './NewsPage';
import ProductosPage from './ProductosPage';
import ProductDetailPage from './ProductDetailPage';
import { 
  Preloader 
} from './LazyLoader';
import MembersManagement from './MembersManagement';
import UserManagement from './UserManagement';
import SystemSettings from './SystemSettings';
import ActivityLogs from './ActivityLogs';
import ProductManagement from './ProductManagement';
import TestimoniosAdmin from './TestimoniosAdmin';
import InvoicesManagement from './InvoicesManagement';
import OrdersManagement from './OrdersManagement';
import PackagingManagement from './PackagingManagement';
import QuotationsManagement from './QuotationsManagement';
import QuotationPublicUploadPage from './QuotationPublicUploadPage';
import UserLogin from './UserLogin';
import UserRegistration from './UserRegistration';
import SimpleDashboard from './SimpleDashboard';
import ErrorBoundary from './ErrorBoundary';
import { adminService } from '../services/api';
import { ADMIN_OPS_REFRESH } from '../constants/adminEvents';
import ResetPasswordPage from './ResetPasswordPage';
import TermsAndConditionsPage from './TermsAndConditionsPage';
import PrivacyPolicyPage from './PrivacyPolicyPage';
import RefundPolicyPage from './RefundPolicyPage';
import './AppRouter.css';

/** Lee sesión staff guardada (localStorage). */
function readAdminSessionFromStorage() {
  try {
    const token = localStorage.getItem('javiland_token');
    const userRaw = localStorage.getItem('javiland_user');
    if (token && userRaw) {
      const user = JSON.parse(userRaw);
      return { ok: true, user };
    }
    if (token) localStorage.removeItem('javiland_token');
    if (userRaw) localStorage.removeItem('javiland_user');
  } catch (e) {
    localStorage.removeItem('javiland_token');
    localStorage.removeItem('javiland_user');
  }
  return { ok: false, user: null };
}

/**
 * Pathname del navegador → clave `currentPage` (misma lógica en carga inicial y en popstate).
 */
function resolvePageFromPath(pathname, search) {
  const path = (pathname || '/').replace(/\/$/, '') || '/';

  if (path.startsWith('/cotizacion-adjuntos/') && path.replace('/cotizacion-adjuntos/', '').length >= 16) {
    return { page: 'quotation-upload' };
  }

  if (path === '/unete') {
    return { page: 'comunidad', replacePath: '/comunidad' };
  }
  if (path === '/news') {
    return { page: 'noticias', replacePath: '/noticias' };
  }
  if (path === '/comunidad/restablecer') {
    return { page: 'comunidad-restablecer' };
  }
  if (path.startsWith('/comunidad')) {
    return { page: 'comunidad' };
  }
  if (path === '/reset-password' && String(search || '').includes('token=')) {
    return { page: 'reset-password' };
  }
  if (path === '/admin-login') {
    return { page: 'admin-login' };
  }
  if (path === '/perfil') {
    return { page: 'perfil' };
  }
  if (path === '/politicas/terminos' || path === '/terms-and-conditions') {
    return { page: 'terms-and-conditions' };
  }
  if (path === '/politicas/privacidad' || path === '/privacy-policy') {
    return { page: 'privacy-policy' };
  }
  if (path === '/refund-policy') {
    return { page: 'refund-policy' };
  }
  if (path === '/ecommerce' || path === '/tienda') {
    return { page: 'tienda' };
  }
  if (path === '/bienestar') {
    return { page: 'bienestar' };
  }
  if (path === '/conoce-colombia') {
    return { page: 'conoce-colombia' };
  }
  if (path === '/rentas') {
    return { page: 'servicios', replacePath: '/servicios' };
  }
  if (path === '/voluntariado') {
    return { page: 'voluntariado' };
  }
  if (path === '/conecta-tu-camino') {
    return { page: 'conecta-tu-camino' };
  }
  if (path === '/contacto') {
    return { page: 'contacto' };
  }
  if (path === '/noticias') {
    return { page: 'noticias' };
  }
  if (path === '/servicios') {
    return { page: 'servicios' };
  }
  if (path === '/checkout' || path.startsWith('/checkout/')) {
    return { page: 'checkout' };
  }
  if (path === '/quienes-somos') {
    return { page: 'quienes-somos' };
  }
  if (path === '/productos') {
    return { page: 'productos' };
  }
  if (path.match(/^\/producto\/\d+$/)) {
    return { page: 'producto-detail' };
  }
  if (path === '/growth-partner') {
    return { page: 'growth-partner' };
  }
  if (path === '/admin') {
    return { page: 'admin' };
  }
  if (path === '/login') {
    return { page: 'user-login' };
  }
  if (path === '/register') {
    return { page: 'user-register' };
  }
  return { page: 'home' };
}

/** Sin sesión: /admin → login staff. Con sesión: /admin-login → panel (evita “segundo paso”). */
function applyAdminRouteGuards(page) {
  const { ok } = readAdminSessionFromStorage();
  if (page === 'admin' && !ok) {
    window.history.replaceState({}, '', '/admin-login');
    return 'admin-login';
  }
  if (page === 'admin-login' && ok) {
    window.history.replaceState({}, '', '/admin');
    return 'admin';
  }
  return page;
}

function computeInitialRoutingState() {
  if (typeof window === 'undefined') {
    return {
      currentPage: 'home',
      isAuthenticated: false,
      currentUser: null
    };
  }
  const sess = readAdminSessionFromStorage();
  const raw = resolvePageFromPath(window.location.pathname, window.location.search);
  if (raw.replacePath) {
    window.history.replaceState({}, '', raw.replacePath);
  }
  let page = applyAdminRouteGuards(raw.page);

  return {
    currentPage: page,
    isAuthenticated: sess.ok,
    currentUser: sess.user
  };
}

const initialRouting = computeInitialRoutingState();

function AdminNavBadge({ count }) {
  const n = Number(count) || 0;
  if (n < 1) return null;
  return (
    <span className="admin-nav-badge" title="Pendientes de revisión" aria-hidden="true">
      {n > 99 ? '99+' : n}
    </span>
  );
}

const AppRouter = () => {
  const [currentPage, setCurrentPage] = useState(initialRouting.currentPage);
  const [adminSection, setAdminSection] = useState('dashboard');
  const [isAuthenticated, setIsAuthenticated] = useState(initialRouting.isAuthenticated);
  const [currentUser, setCurrentUser] = useState(initialRouting.currentUser);
  const [operationsSummary, setOperationsSummary] = useState(null);

  const refreshOperationsSummary = useCallback(async () => {
    try {
      const data = await adminService.getOperationsSummary();
      setOperationsSummary(data);
    } catch (e) {
      console.warn('operations-summary:', e.response?.status || e.message);
    }
  }, []);

  useEffect(() => {
    if (!isAuthenticated || currentPage !== 'admin') return undefined;
    refreshOperationsSummary();
    const iv = window.setInterval(refreshOperationsSummary, 75000);
    const onEvt = () => refreshOperationsSummary();
    window.addEventListener(ADMIN_OPS_REFRESH, onEvt);
    return () => {
      window.clearInterval(iv);
      window.removeEventListener(ADMIN_OPS_REFRESH, onEvt);
    };
  }, [isAuthenticated, currentPage, refreshOperationsSummary]);

  useEffect(() => {
    const syncFromUrl = () => {
      const raw = resolvePageFromPath(window.location.pathname, window.location.search);
      if (raw.replacePath) {
        window.history.replaceState({}, '', raw.replacePath);
      }
      const page = applyAdminRouteGuards(raw.page);
      setCurrentPage(page);
    };

    window.addEventListener('popstate', syncFromUrl);
    return () => window.removeEventListener('popstate', syncFromUrl);
  }, []);


  const renderPage = () => {
    switch (currentPage) {
      case 'admin':
        if (!isAuthenticated) {
          return (
            <ErrorBoundary>
              <AdminLoginPage onLoginSuccess={handleLoginSuccess} />
            </ErrorBoundary>
          );
        }
        switch (adminSection) {
          case 'dashboard':
            return (
              <ErrorBoundary>
                <SimpleDashboard operationsSummary={operationsSummary} />
              </ErrorBoundary>
            );
          case 'members':
            return (
              <ErrorBoundary>
                <MembersManagement />
              </ErrorBoundary>
            );
          case 'users':
            return (
              <ErrorBoundary>
                <UserManagement />
              </ErrorBoundary>
            );
          case 'settings':
            return (
              <ErrorBoundary>
                <SystemSettings />
              </ErrorBoundary>
            );
          case 'logs':
            return (
              <ErrorBoundary>
                <ActivityLogs />
              </ErrorBoundary>
            );
          case 'products':
            return (
              <ErrorBoundary>
                <ProductManagement />
              </ErrorBoundary>
            );
          case 'testimonios':
            return (
              <ErrorBoundary>
                <TestimoniosAdmin />
              </ErrorBoundary>
            );
          case 'orders':
            return (
              <ErrorBoundary>
                <OrdersManagement />
              </ErrorBoundary>
            );
          case 'packaging':
            return (
              <ErrorBoundary>
                <PackagingManagement />
              </ErrorBoundary>
            );
          case 'invoices':
            return (
              <ErrorBoundary>
                <InvoicesManagement />
              </ErrorBoundary>
            );
          case 'cotizaciones':
            return (
              <ErrorBoundary>
                <QuotationsManagement />
              </ErrorBoundary>
            );
          default:
            return (
              <ErrorBoundary>
                <SimpleDashboard operationsSummary={operationsSummary} />
              </ErrorBoundary>
            );
        }
      case 'quotation-upload':
        return (
          <ErrorBoundary>
            <QuotationPublicUploadPage />
          </ErrorBoundary>
        );
      case 'bienestar':
        return (
          <ErrorBoundary>
            <BienestarPage />
          </ErrorBoundary>
        );
      case 'conoce-colombia':
        return (
          <ErrorBoundary>
            <ConoceColombiaPage />
          </ErrorBoundary>
        );
      case 'voluntariado':
        return (
          <ErrorBoundary>
            <VoluntariadoPage />
          </ErrorBoundary>
        );
      case 'conecta-tu-camino':
        return (
          <ErrorBoundary>
            <ConectaTuCaminoPage />
          </ErrorBoundary>
        );
      case 'contacto':
        return (
          <ErrorBoundary>
            <ContactoPage />
          </ErrorBoundary>
        );
      case 'noticias':
        return (
          <ErrorBoundary>
            <NewsPage />
          </ErrorBoundary>
        );
      case 'servicios':
        return (
          <ErrorBoundary>
            <ServiciosPage />
          </ErrorBoundary>
        );
      case 'tienda':
        return (
          <ErrorBoundary>
            <TiendaPage />
          </ErrorBoundary>
        );
      case 'growth-partner':
        return (
          <ErrorBoundary>
            <GrowthPartnerPage />
          </ErrorBoundary>
        );
      case 'checkout':
        return (
          <ErrorBoundary>
            <Checkout />
          </ErrorBoundary>
        );
      case 'quienes-somos':
        return (
          <ErrorBoundary>
            <QuienesSomosPage />
          </ErrorBoundary>
        );
      case 'productos':
        return (
          <ErrorBoundary>
            <ProductosPage />
          </ErrorBoundary>
        );
      case 'producto-detail':
        return (
          <ErrorBoundary>
            <ProductDetailPage key={window.location.pathname} />
          </ErrorBoundary>
        );
      case 'reset-password':
        return (
          <ErrorBoundary>
            <ResetPasswordPage 
              onClose={() => setCurrentPage('home')}
              onSuccess={() => {
                window.history.pushState({}, '', '/admin-login');
                setCurrentPage('admin-login');
              }}
            />
          </ErrorBoundary>
        );
      case 'terms-and-conditions':
        return (
          <ErrorBoundary>
            <TermsAndConditionsPage />
          </ErrorBoundary>
        );
      case 'privacy-policy':
        return (
          <ErrorBoundary>
            <PrivacyPolicyPage />
          </ErrorBoundary>
        );
      case 'refund-policy':
        return (
          <ErrorBoundary>
            <RefundPolicyPage />
          </ErrorBoundary>
        );
      case 'comunidad':
        return (
          <ErrorBoundary>
            <ComunidadPage />
          </ErrorBoundary>
        );
      case 'comunidad-restablecer':
        return (
          <ErrorBoundary>
            <MemberResetPasswordPage />
          </ErrorBoundary>
        );
      case 'admin-login':
        return (
          <ErrorBoundary>
            <AdminLoginPage onLoginSuccess={handleLoginSuccess} />
          </ErrorBoundary>
        );
      case 'perfil':
        return (
          <ErrorBoundary>
            <MemberPerfilPage />
          </ErrorBoundary>
        );
      case 'user-login':
        return (
          <ErrorBoundary>
            <UserLogin />
          </ErrorBoundary>
        );
      case 'user-register':
        return (
          <ErrorBoundary>
            <UserRegistration />
          </ErrorBoundary>
        );
      case 'home':
      default:
        return (
          <>
            <Hero onShowLogin={goToComunidad} />
            <ViveLibreSection />
            <Values />
            <Services />
            <Testimonials />
            <Gallery />
          </>
        );
    }
  };

  const goToAdmin = () => {
    if (isAuthenticated) {
      window.history.pushState({}, '', '/admin');
      setCurrentPage('admin');
    } else {
      window.history.pushState({}, '', '/admin-login');
      setCurrentPage('admin-login');
    }
  };

  const goToComunidad = () => {
    window.history.pushState({}, '', '/comunidad');
    setCurrentPage('comunidad');
  };

  const goToHome = () => {
    window.history.pushState({}, '', '/');
    setCurrentPage('home');
  };
  
  const goToEcommerce = () => {
    window.history.pushState({}, '', '/tienda');
    setCurrentPage('tienda');
  };

  const handleLoginSuccess = (userData) => {
    setIsAuthenticated(true);
    setCurrentUser(userData);
    window.history.pushState({}, '', '/admin');
    setCurrentPage('admin');
  };

  const handleLogout = async () => {
    localStorage.removeItem('javiland_token');
    localStorage.removeItem('javiland_user');

    setIsAuthenticated(false);
    setCurrentUser(null);
    setCurrentPage('home');

    window.location.href = '/';
  };

  return (
    <div className="app">
      {/* Header general - Solo visible en home, e-commerce, términos y privacidad, NO en admin ni checkout */}
      {currentPage !== 'admin' && currentPage !== 'admin-login' && currentPage !== 'reset-password' && currentPage !== 'user-login' && currentPage !== 'user-register' && currentPage !== 'checkout' && (
        <Header onCommunityClick={goToComunidad} onEcommerceClick={goToEcommerce} />
      )}
      
      {/* Navegación de páginas - Solo visible en panel administrativo */}
      {currentPage === 'admin' && (
        <div className="page-navigation">
          <button 
            onClick={goToHome}
            className={`nav-btn ${currentPage === 'home' ? 'active' : ''}`}
          >
            <i className="fas fa-home"></i>
            <span>Inicio</span>
          </button>
          <button 
            onClick={goToAdmin}
            className={`nav-btn ${currentPage === 'admin' ? 'active' : ''}`}
          >
            <i className="fas fa-shield-alt"></i>
            <span>Administración</span>
          </button>
          
          {isAuthenticated && currentUser && (
            <div className="user-info">
              <span className="user-name">
                <i className="fas fa-user-circle"></i>
                {currentUser.name}
              </span>
              <button onClick={handleLogout} className="logout-btn">
                <i className="fas fa-sign-out-alt"></i>
                <span>Cerrar Sesión</span>
              </button>
            </div>
          )}
        </div>
      )}

        {/* Navegación administrativa */}
        {isAuthenticated && currentPage === 'admin' && (
          <div className="admin-navigation">
            <button 
              className={`admin-nav-btn ${adminSection === 'dashboard' ? 'active' : ''}`}
              onClick={() => setAdminSection('dashboard')}
            >
              <i className="fas fa-chart-line"></i>
              <span>Dashboard</span>
            </button>
            <button 
              className={`admin-nav-btn ${adminSection === 'members' ? 'active' : ''}`}
              onClick={() => setAdminSection('members')}
            >
              <i className="fas fa-users"></i>
              <span>Miembros</span>
            </button>
            <button 
              className={`admin-nav-btn ${adminSection === 'users' ? 'active' : ''}`}
              onClick={() => setAdminSection('users')}
            >
              <i className="fas fa-user-cog"></i>
              <span>Usuarios</span>
            </button>
            <button 
              className={`admin-nav-btn ${adminSection === 'settings' ? 'active' : ''}`}
              onClick={() => setAdminSection('settings')}
            >
              <i className="fas fa-cog"></i>
              <span>Configuración</span>
            </button>
            <button 
              className={`admin-nav-btn ${adminSection === 'logs' ? 'active' : ''}`}
              onClick={() => setAdminSection('logs')}
            >
              <i className="fas fa-clipboard-list"></i>
              <span>Logs</span>
            </button>
            <button 
              className={`admin-nav-btn admin-nav-btn--badge-wrap ${adminSection === 'orders' ? 'active' : ''}`}
              onClick={() => setAdminSection('orders')}
              type="button"
            >
              <i className="fas fa-shopping-cart"></i>
              <span>Órdenes</span>
              <AdminNavBadge count={operationsSummary?.badges?.orders} />
            </button>
            <button 
              className={`admin-nav-btn admin-nav-btn--badge-wrap ${adminSection === 'packaging' ? 'active' : ''}`}
              onClick={() => setAdminSection('packaging')}
              type="button"
            >
              <i className="fas fa-box"></i>
              <span>Empaque</span>
              <AdminNavBadge count={operationsSummary?.badges?.packaging} />
            </button>
            <button 
              className={`admin-nav-btn ${adminSection === 'products' ? 'active' : ''}`}
              onClick={() => setAdminSection('products')}
            >
              <i className="fas fa-tshirt"></i>
              <span>Productos</span>
            </button>
            <button 
              className={`admin-nav-btn admin-nav-btn--badge-wrap ${adminSection === 'testimonios' ? 'active' : ''}`}
              onClick={() => setAdminSection('testimonios')}
              type="button"
            >
              <i className="fas fa-comments"></i>
              <span>Testimonios</span>
              <AdminNavBadge count={operationsSummary?.badges?.testimonials} />
            </button>
            <button 
              className={`admin-nav-btn admin-nav-btn--badge-wrap ${adminSection === 'invoices' ? 'active' : ''}`}
              onClick={() => setAdminSection('invoices')}
              type="button"
            >
              <i className="fas fa-file-invoice"></i>
              <span>Facturas</span>
              <AdminNavBadge count={operationsSummary?.badges?.invoices} />
            </button>
            <button 
              className={`admin-nav-btn ${adminSection === 'cotizaciones' ? 'active' : ''}`}
              onClick={() => setAdminSection('cotizaciones')}
              type="button"
            >
              <i className="fas fa-file-signature"></i>
              <span>Cotizaciones</span>
            </button>
          </div>
        )}

      {/* Contenido de la página */}
      <main className={`main-content${currentPage === 'admin-login' ? ' main-content--no-header' : ''}`}>
        {renderPage()}
      </main>

      {currentPage !== 'admin' && currentPage !== 'admin-login' && currentPage !== 'reset-password' && currentPage !== 'user-login' && currentPage !== 'user-register' && currentPage !== 'checkout' && currentPage !== 'quotation-upload' && (
        <Footer onAdminNavigate={goToAdmin} />
      )}

      {/* Carrito de compras - Visible en todas las páginas excepto admin y checkout */}
      {currentPage !== 'admin' && currentPage !== 'admin-login' && currentPage !== 'checkout' && currentPage !== 'reset-password' && currentPage !== 'user-login' && currentPage !== 'user-register' && currentPage !== 'quotation-upload' && <ShoppingCart />}

      {/* Preloader para componentes críticos */}
      <Preloader />
    </div>
  );
};

export default AppRouter;
